import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import type { ApiIncomingIdentitySubscriptionsPage } from "@/generated/models/ApiIncomingIdentitySubscriptionsPage";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
const REQUEST_SIZE = 100;
export default function useFollowersList(t0) {
  const $ = _c(24);
  const {
    profileId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      page_size: `${REQUEST_SIZE}`
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const query = t2;
  let t3;
  let t4;
  if ($[1] !== profileId) {
    t3 = [QueryKey.IDENTITY_FOLLOWERS, {
      ...query,
      target_type: "IDENTITY",
      profile_id: profileId
    }];
    t4 = async t5 => {
      const {
        pageParam
      } = t5;
      const params = {
        ...query
      };
      if (pageParam) {
        params.page = `${pageParam}`;
      }
      return await commonApiFetch({
        endpoint: `/identity-subscriptions/incoming/IDENTITY/${profileId}`,
        params
      });
    };
    $[1] = profileId;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = !!profileId && enabled;
  let t6;
  if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      initialPageParam: null,
      getNextPageParam: _temp
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  } = useInfiniteQuery(t6);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const [followers, setFollowers] = useState(t7);
  let t8;
  if ($[9] !== data?.pages) {
    t8 = () => setFollowers(data?.pages.flatMap(_temp2) ?? []);
    $[9] = data?.pages;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== data) {
    t9 = [data];
    $[11] = data;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  useEffect(t8, t9);
  let t10;
  if ($[13] !== fetchNextPage || $[14] !== followers || $[15] !== hasNextPage || $[16] !== isFetching || $[17] !== isFetchingNextPage || $[18] !== status) {
    t10 = state => {
      if (followers.length < REQUEST_SIZE) {
        return;
      }
      if (!state) {
        return;
      }
      if (status === "pending") {
        return;
      }
      if (isFetching) {
        return;
      }
      if (isFetchingNextPage) {
        return;
      }
      if (!hasNextPage) {
        return;
      }
      fetchNextPage();
    };
    $[13] = fetchNextPage;
    $[14] = followers;
    $[15] = hasNextPage;
    $[16] = isFetching;
    $[17] = isFetchingNextPage;
    $[18] = status;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const onBottomIntersection = t10;
  let t11;
  if ($[20] !== followers || $[21] !== isFetching || $[22] !== onBottomIntersection) {
    t11 = {
      followers,
      isFetching,
      onBottomIntersection
    };
    $[20] = followers;
    $[21] = isFetching;
    $[22] = onBottomIntersection;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
function _temp2(page) {
  return page.data;
}
function _temp(lastPage) {
  return lastPage.next ? lastPage.page + 1 : null;
}